var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTumblrMobileReblog = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 20,
  viewBox: "0 0 21 20",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M19.974 9.145v6.698c0 .262-.553.834-.804.834H4.738v2.949L0 15.395l4.742-4.75v3.032h11.695c.077 0 .387-.263.387-.3v-1.52zM15.834 0l4.876 4.636-4.877 4.625V6.177H4.046c-.181 0-.427.284-.427.284l.053 1.625L.535 10.85V3.992c0-.271.59-.815.884-.815h14.413z"
})));
export default SvgTumblrMobileReblog;